import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import OperationsList from 'views/Components/OperationsList'
import CircularProgress from '@material-ui/core/CircularProgress'
import api from 'api'
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Pagination from 'views/Components/Pagination.jsx'
import style from "assets/css/style.jsx"

const styles = require(`../../assets/css/style.jsx`).default;

      const brands = [
          {
              value: 'VICHY',
              label: 'Vichy',
          },
          {
              value: 'SkinCeuticals',
              label: 'SkinCeuticals',
          },
          {
              value: 'LA-ROCHE-POSAY',
              label: 'La Roche-Posay',
          },
          {
              value: 'Sanoflore',
              label: 'Sanoflore',
          },
          {
              value: 'ROGER&GALLET',
              label: 'Roger & Gallet',
          },
          {
              value: 'CERAVE',
              label: 'CeraVe',
          },
      ];
const statusOperations = [
  {
    value: 'active',
    label: 'En cours',
  },
  {
    value: 'nonActive',
    label: 'Terminée',
  },
];

const currencies = [
    {
        value: 5,
        label: '5',
    },
    {
        value: 10,
        label: '10',
    },
    {
        value: 20,
        label: '20',
    },
    {
        value: 30,
        label: '30',
    },
    {
        value: 40,
        label: '40',
    },
    {
        value: 50,
        label: '50',
    },
];

class OperationsPage extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            operations: [],
            users: [],
            renderedUsers: [],
            progress: false,
            filter: "",
            searchTitle:'',
            searchBrands:'',
            searchStatus:'',
            currency:50,
            allCountries: [],
            currentCountries: [],
            currentPage: null,
            totalPages: null,
            postsPerPage:10,
            page:1,
            click:false,
            count:25

        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

  componentDidMount() {
    this.setState({progress: true});
    const {searchTitle, searchBrands, searchStatus} = this.state;
    api.operations.my_operations(this.state.currency)
      .then(resp => {
        this.setState({operations: resp.data['hydra:member'], progress: false})
        const allCountries = this.state.operations;
        this.setState({ allCountries });
        let nexdate = new Date()
        let day = nexdate.getDate();
        let year = nexdate.getFullYear();
        let month = nexdate.getMonth();
        const filteredCountries = allCountries.filter(country => {
            if(searchTitle) {
                return country.title.toLowerCase().indexOf(searchTitle.toLowerCase()) !== -1;
            }
            else if(searchBrands){
                return country.brand && country.brand.name.toLowerCase().indexOf(searchBrands.toLowerCase()) !== -1;
              }
            else if(searchStatus === 'active'){
                if(country.closingDate > year+'-'+month+'-'+day) {
                    return country;
                }
            }
            else if(searchStatus === 'nonActive'){
                if(country.closingDate < year+'-'+month+'-'+day) {
                    return country;
                }
            }
            else if(searchStatus === '' ){
                return country.title.toLowerCase().indexOf(searchTitle.toLowerCase()) !== -1;
            }
        })
        setTimeout(() => {
          this.setState({
            users:this.state.users,
            renderedUsers: filteredCountries.slice(0, 5),
            total: filteredCountries.length
          });
        });

      })
      .catch(err => this.setState({progress: false}))
  }

  onchange = e => {
    this.setState({ searchTitle: e.target.value, searchBrands:'', searchStatus:'',click:false });
  };
  onchangeBrands = e=> {
    let countnew = Math.ceil(this.state.total / 5);
    this.setState({ searchBrands: e.target.value, searchTitle:'', searchStatus:'', click:false,  count:countnew});
  }

  onchangeStatus = e => {
      this.setState({ searchStatus: e.target.value, searchTitle:'', searchBrands:'',click:false });
  };
  onChangeReset=()=>{
    this.setState({ searchStatus: '', searchTitle:'', searchBrands:'',click:false });
  };
    onChangeCurrency=e=>{
      this.setState({ currency: e.target.value });
      api.operations.my_operations( e.target.value)
        .then(resp => this.setState({operations: resp.data['hydra:member'], progress: false}))
        .catch(err => this.setState({progress: false}))
  };
  handlePageChange(page) {
    const { allCountries,progress, searchTitle, searchBrands, searchStatus, currency, total} = this.state;
    let nexdate = new Date()
    let day = nexdate.getDate();
    let year = nexdate.getFullYear();
    let month = nexdate.getMonth();
    const filteredCountries = allCountries.filter(country => {
        if(searchTitle) {
            return country.title.toLowerCase().indexOf(searchTitle.toLowerCase()) !== -1;
        }
        else if(searchBrands){
            return country.brand && country.brand.name.toLowerCase().indexOf(searchBrands.toLowerCase()) !== -1;
          }
        else if(searchStatus === 'active'){
            if(country.closingDate < year+'-'+month+'-'+day) {
                return country;
            }
        }
        else if(searchStatus === 'nonActive'){
            if(country.closingDate > year+'-'+month+'-'+day) {
                return country;
            }
        }
        else if(searchStatus === '' ){
            return country.title.toLowerCase().indexOf(searchTitle.toLowerCase()) !== -1;
        }
    });
    const renderedUsers = filteredCountries.slice((page - 1) * 5, (page - 1) * 5 + 5);
    let countnew = Math.ceil(total / 5);

      this.setState({
        click:true,
        page,
        renderedUsers,
        count:countnew

      });

  }

    render() {
    const { classes } = this.props;
    const { allCountries,progress, searchTitle, searchBrands, searchStatus, currency, page,total, renderedUsers} = this.state;
    let nexdate = new Date()
    let day = nexdate.getDate();
    let year = nexdate.getFullYear();
    let month = nexdate.getMonth();
    let countnew = Math.ceil(total / 5);
    let filterToo = allCountries.filter(country => {
        if(searchTitle) {
            return country.title.toLowerCase().indexOf(searchTitle.toLowerCase()) !== -1;
        }
        else if(searchBrands){
            return country.brand && country.brand.name.toLowerCase().indexOf(searchBrands.toLowerCase()) !== -1;
          }
        else if(searchStatus === 'active'){
            if(country.closingDate < year+'-'+month+'-'+day) {
                return country;
            }
        }
        else if(searchStatus === 'nonActive'){
            if(country.closingDate > year+'-'+month+'-'+day) {
                return country;
            }
        }
        else if(searchStatus === '' ){
            return country.title.toLowerCase().indexOf(searchTitle.toLowerCase()) !== -1;
        }
    })
    if(this.state.click == false){

      setTimeout(() => {
          this.setState({
            users:this.state.users,
            renderedUsers: filterToo.slice(0, 5),
            total: filterToo.length,
            count:countnew,

          });
        })
    }
      return (
        <div className={classes.content} style={styles.opListWrapper}>
          <div className={classes.container}>
            <GridContainer justify='center'>
              {progress && <CircularProgress className={classes.title} color="secondary"/>}
              {!progress && <GridItem xs={12} sm={12} md={6}>
              </GridItem>}
            </GridContainer>
            <div style={{marginBottom:'50px', textAlign:'center', display:'none',}}>
              <label style={{verticalAlign: 'bottom', marginRight:'15px'}}>Choix de la marque</label>
              <TextField style={{width:'150px'}} value={searchBrands} select label="Les marques" onChange={this.onchangeBrands}>
                  {brands.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
              </TextField>
              <label style={{verticalAlign: 'bottom', marginRight:'15px'}}><SearchIcon/>Recherche</label>
              <TextField id="standard-basic" label="Titre de l'opération" value={searchTitle} onChange={this.onchange} />
              <label style={{verticalAlign: 'bottom', marginRight:'15px'}} >Statut opération</label>
              <TextField style={{width:'150px'}} value={searchStatus} select label="Statut opération" onChange={this.onchangeStatus}>
                  {statusOperations.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
              </TextField>
              <Button type ='submit' onClick={this.onChangeReset} style={{backgroundColor:'black', color:'white',verticalAlign: 'bottom', marginLeft:'15px'}} variant="contained">Réinitialiser filtre</Button>
            </div>
              <OperationsList operations={renderedUsers} progress={progress} />
              <Pagination
                margin={1}
                page={page}
                count={this.state.count}
                onPageChange={this.handlePageChange}
              />
          </div>
        </div>
    );
  }
}

OperationsPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(style)(OperationsPage);



// WEBPACK FOOTER //
// ./src/views/Pages/OperationsPage.jsx